import { getAddress, getAddressSelect, changeAddress, delAddress } from './api';

const originForm = {
    address_id: '',
    carts: {},
    order_images: '',
    postscript: '',     //备注
    single_number: '',  //订单号
    rec_id: '',
};

const state = {
    addressList: [],
    provinceList: [],
    cityList: [],
    districtList: [],
    dialogVisible: true,
    addressForm: originForm,
    orderForm: originForm, //只有这个state有用
    currAddress: '',
};

const mutations = {
    setAddressList (state, list) {
        state.addressList = list;
    },
    setDialogVisible (state, flag) {
        state.dialogVisible = flag;
    },
    setProvinceList (state, list) {
        state.provinceList = list;
    },
    setCityList (state, list) {
        state.cityList = list;
    },
    setDistrictList (state, list) {
        state.districtList = list;
    },
    setOrderForm (state, params) {
        state.orderForm = Object.assign(state.orderForm, params);
    },
    setCurrAddress (state, id) {
        state.currAddress = id;
    },
};

const actions = {
    async getAddress ({commit}) {
        return getAddress().then(res => {
            const {data} = res;
            if (data.length > 0) {
                const {address_id} = data[0];
                // const {city, province, district, consignee: name, mobile, address} = data[0];
                // commit('setAddressForm', {city, province, district, name, mobile, address});
                commit('setCurrAddress', address_id);
                commit('setAddressList', data);
            }
        });
    },
    async delAddress ({commit}, id) {
        return delAddress(id);
    },
    async changeAddress ({commit, state}, id) {
        if (id !== undefined) {
            return changeAddress(Object.assign(state.addressForm, {address_id: id}));
        } else {
            return changeAddress(state.addressForm);
        }
    },
    async getAddressSelect ({commit, state}, {id, type}) {
        //type 1省2市3区
        return getAddressSelect(id).then(res => {
            const {data} = res;
            switch (type) {
                case 1:
                    commit('setProvinceList', data);
                    if (data.length > 0) {
                        commit('setAddressForm', Object.assign(state.addressForm, {province: data[0].region_id}));
                    }
                    break;
                case 2:
                    commit('setCityList', data);
                    if (data.length > 0) {
                        commit('setAddressForm', Object.assign(state.addressForm, {city: data[0].region_id}));
                    }
                    break;
                case 3:
                    commit('setDistrictList', data);
                    if (data.length > 0) {
                        commit('setAddressForm', Object.assign(state.addressForm, {district: data[0].region_id}));
                    }
                    break;
                default:
                    break;
            }
            return data;
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/stores/supplyChain.js